import { StoreSnapshot } from '@tldraw/tldraw'
import { useRootStore } from 'stores/RootStore'
import { DesignClient } from 'api/clients/DesignClient'
import { useQueryClient } from 'react-query'
import { calendarKeys } from 'hooks/queries/calendar/calendarKeys'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'

export const useApplyDesign = ({ fileId }: { fileId: string }) => {
  const { designStore, files } = useRootStore()
  const queryClient = useQueryClient()

  const applyDesign = async (snapshot: StoreSnapshot<any>) => {
    const body = { content: snapshot }
    await DesignClient.updateDesign(fileId, body)
    if (designStore && designStore.fileId === fileId) {
      await designStore.loadSnapshot(snapshot)
    }

    files.fetch(fileId, true)
    queryClient.invalidateQueries(calendarKeys.all)
    queryClient.invalidateQueries(calendarKeys.detail(fileId))
    showToastMessage('Design updated!', 'success', undefined, 2)
  }

  return {
    applyDesign,
  }
}
